module.exports = __webpack_public_path__ + "img/successIcon.17db9a13.png";